import { css } from '@emotion/react';
import theme from './theme';

const { breakpoints } = theme;

/**
 * Minimum space below the status bar when env(safe-area-inset-top) is 0 (e.g. desktop / non-notched).
 * Pairs with viewport-fit=cover; see siteHeaderTopSafePadding.
 */
export const SITE_HEADER_TOP_MIN_PADDING_PX = 12;

/**
 * Same as above for viewports at `smallLaptop` and up (tighter than the legacy 70px margin).
 */
export const SITE_HEADER_TOP_MIN_PADDING_DESKTOP_PX = 24;

/** Mobile nav row: logo is vertically centered in this band (see Navigation LogoWrapper). */
export const MOBILE_LOGO_ROW_MIN_HEIGHT_PX = 48;

/**
 * Pushes global header (logo, menu) below the device safe area; background can extend with viewport-fit cover.
 * Use on Navigation; keep `MobileHeaderActions` top and mobile menu `MainLinksWrapper` margin in sync.
 */
export const siteHeaderTopSafePadding = css`
  padding-top: max(${SITE_HEADER_TOP_MIN_PADDING_PX}px, env(safe-area-inset-top, 0px));
  @media screen and (min-width: ${breakpoints.smallLaptop}) {
    padding-top: max(${SITE_HEADER_TOP_MIN_PADDING_DESKTOP_PX}px, env(safe-area-inset-top, 0px));
  }
`;

/**
 * Fixed mobile menu / language controls; vertically centers on the same row as the logo
 * (padding top + half of MOBILE_LOGO_ROW_MIN_HEIGHT_PX).
 */
export const mobileHeaderActionsPosition = css`
  top: calc(max(${SITE_HEADER_TOP_MIN_PADDING_PX}px, env(safe-area-inset-top, 0px)) + ${MOBILE_LOGO_ROW_MIN_HEIGHT_PX / 2}px);
  transform: translateY(-50%);
`;
